module.exports = __webpack_public_path__ + "img/9.5bcf30d7.png";